import { Auth } from '@jg/auth';

const generateAuthHeaders = (auth: Auth) => {
  const authCookie = auth.getParsedAuthCookie();
  if (authCookie) {
    return {
      Authorization: `Bearer ${authCookie.accessToken}`,
    };
  }
  return undefined;
};

export default generateAuthHeaders;
